import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VList,{attrs:{"two-line":""}},[_c(VSubheader,[_vm._v("Aircraft")]),_c(VListItem,[_c(VListItemContent,[_c(VListItemTitle,[_vm._v(" Registration ")]),_c(VListItemSubtitle,[_vm._v(" "+_vm._s(_vm.value.aircraft)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }